import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type { DataTableAdapter } from '@app/modules/assets/models/data-table.model';
import { DATA_TABLE_PATH } from '@app/shared/constants/api-route.config';
import { type ListResponse, WithCrudService } from '@app/shared/services/mixins/crud.service';
import { WithLineageService } from '@app/shared/services/mixins/lineage.service';
import { WithLogService } from '@app/shared/services/mixins/log.service';
import { RestService } from '@app/shared/services/rest.service';

@Injectable({
    providedIn: 'root',
})
export class DataTableService extends classes(
    WithLogService,
    WithLineageService,
    WithCrudService<DataTableAdapter>,
) {
    protected endpoint = DATA_TABLE_PATH;

    protected readonly api = inject(RestService);

    getAll(params = {}): Observable<ListResponse<DataTableAdapter>> {
        return this.api.getWithParams(this.endpoint, params);
    }

    previewData(
        dataTableId: number,
        params: {
            query: string;
            isDefaultQuery: boolean;
        },
        options?: { transactionId: number },
    ): Observable<{
        result: {
            data: { columns: string[]; data: string[][]; metadata?: { fetchedAt: string } };
            logs?: string;
        };
    }> {
        const url = this.constructURL(`${this.endpoint}${dataTableId}`, options?.transactionId);
        return this.api.post(`${url}/preview_data`, params);
    }

    previewUnsavedData(dataTable: DataTableAdapter): Observable<{
        result: {
            data: { columns: string[]; data: string[][]; metadata?: { fetchedAt: string } };
            logs?: string;
        };
    }> {
        return this.api.post(`${this.endpoint}preview_data`, dataTable);
    }
}
